export default "__VITE_ASSET__DOttBT01__"